// extracted by mini-css-extract-plugin
export default {"p":"Info_p__QQAbi","text":"Info_text__ee9g3"};